import React from 'react';
import PropTypes from 'prop-types';

const OutboundLink = ({
  href,
  className,
  children = null,
  onClick = () => {},
  dataLinkType = 'text-link',
  target = '_blank',
}) => (
  <a className={className} href={href} target={target} rel="noopener noreferrer" data-link-type={dataLinkType} onClick={onClick}>
    {children}
  </a>
);

OutboundLink.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  dataLinkType: PropTypes.string,
};

export default OutboundLink;
